import clsx from "clsx";
import "./CreateReservationModalContent.scss";

type CreateReservationModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const CreateReservationModalContent = ({
  overrideClassNames,
  children,
}: CreateReservationModalContentProps) => {
  return (
    <div className={clsx("ui-consent-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
